module.exports = __webpack_public_path__ + "img/concern_new.43622a82.png";